import {signalRHubFactory} from '../../../app/vendors/signalRHubFactory';

export const subscriptionHub = signalRHubFactory({name: 'subscriptionHub'});
